import { QuizQuestion } from '../../api/quiz-services';

export const assessmentMetadata = {
    title: "Assessment 1",
    duration: 15
};

export const module1Questions: QuizQuestion[] = [
    {
        id: "M1-001",
        moduleId: "module-1",
        category: "HTS",
        text: "The Highway Transportation System (HTS) is composed of three parts: People, Vehicles, and ____.",
        options: ["Roadways", "Bridges", "Traffic Signs", "Pedestrians"],
        correctAnswer: 0,
        scenario: "The Highway Transportation System (HTS) is composed of three critical parts that must work in absolute harmony: **People (the road users)**, **Vehicles (from bikes to semi-trucks)**, and **Roadways (the physical infrastructure)**.",
        explanation: ""
    },
    {
        id: "M1-002",
        moduleId: "module-1",
        category: "Laws",
        text: "Which government branch is responsible for writing traffic laws?",
        options: ["Executive", "Legislative", "Judicial", "Local Police"],
        correctAnswer: 1,
        scenario: "The **Legislative branch** (General Assembly in Ohio) is solely responsible for writing and enacting traffic laws, while the Executive branch enforces them and the Judicial branch interprets and adjudicates violations.",
        explanation: ""
    },
    {
        id: "M1-003",
        moduleId: "module-1",
        category: "Laws",
        text: "The 'Golden Rule' of driving is to treat others the way you want to be treated. This is part of the ____.",
        options: ["Legal Code", "Social Contract", "Driver's Handbook", "Vehicle Code"],
        correctAnswer: 1,
        scenario: "The 'Golden Rule'—treating others as you wish to be treated—is the core of the **Social Contract** of driving. By driving predictably, showing courtesy, and cooperating rather than competing, you actively preserve system safety.",
        explanation: ""
    },
    {
        id: "M1-004",
        moduleId: "module-1",
        category: "HTS",
        text: "Which of the following is the most complex element of the HTS?",
        options: ["Vehicles", "Roadways", "People", "Environment"],
        correctAnswer: 2,
        scenario: "The **People** (road users) element is by far the most complex and difficult to control. Humans are subject to emotions, distraction, physical fatigue, and varying skill levels, making them the primary source of system failures.",
        explanation: ""
    },
    {
        id: "M1-005",
        moduleId: "module-1",
        category: "Security",
        text: "Before entering your car, you should check for any ____ around the vehicle.",
        options: ["Fluid leaks", "Animals or children", "Obstacles", "All of the above"],
        correctAnswer: 3,
        scenario: "Before every flight, a pilot performs a walkaround. In driving, you must check for **obstacles, fluid leaks, and children or animals** behind or under your vehicle. This pre-entry check prevents low-speed backover tragedy.",
        explanation: ""
    },
    {
        id: "M1-006",
        moduleId: "module-1",
        category: "HTS",
        text: "The primary purpose of the HTS is to move people and cargo ____.",
        options: ["Quickly", "Safely and efficiently", "Cheaply", "Privately"],
        correctAnswer: 1,
        scenario: "The primary purpose of the HTS is to move passengers and cargo **safely and efficiently**. High speeds or low costs are secondary; safety is the absolute foundation of the system's design.",
        explanation: ""
    },
    {
        id: "M1-007",
        moduleId: "module-1",
        category: "Laws",
        text: "Ohio Revised Code (ORC) Title 45 contains the majority of the state's ____ laws.",
        options: ["Criminal", "Traffic", "Property", "Tax"],
        correctAnswer: 1,
        scenario: "The majority of Ohio's traffic and driving regulations are legally codified under **ORC Title 45** (Motor Vehicles - Aeronautics - Watercraft). Mastering these rules is a prerequisite for passing your state test.",
        explanation: ""
    },
    {
        id: "M1-008",
        moduleId: "module-1",
        category: "Maintenance",
        text: "Checking your tire pressure monthly helps improve ____.",
        options: ["Fuel economy", "Braking distance", "Tire lifespan", "All of the above"],
        correctAnswer: 3,
        scenario: "Checking tire pressure monthly improves **fuel economy, tire lifespan, and braking distance**. Tires are your only contact patch with the road; under-inflation leads to heat buildup, tread wear, and catastrophic traction loss during emergency maneuvers.",
        explanation: ""
    },
    {
        id: "M1-009",
        moduleId: "module-1",
        category: "Strategy",
        text: "Risk in driving is always ____.",
        options: ["Eliminated", "Predictable", "Present", "Zero for experts"],
        correctAnswer: 2,
        scenario: "No. **Risk is always present** in driving. Even the most expert, defensive drivers cannot control the actions of other motorists, sudden weather shifts, or hidden mechanical failures. Your goal is active risk mitigation, not the illusion of zero risk.",
        explanation: ""
    },
    {
        id: "M1-010",
        moduleId: "module-1",
        category: "Strategy",
        text: "The three levels of driving tasks are Strategic, Tactical, and ____.",
        options: ["Operational", "Critical", "Physical", "Mental"],
        correctAnswer: 0,
        scenario: "The three levels are: **Strategic** (planning route, weather analysis), **Tactical** (maneuvering in traffic, intersection decisions), and **Operational** (physical inputs like steering, braking, and gear selection).",
        explanation: ""
    },
    {
        id: "M1-011",
        moduleId: "module-1",
        category: "Laws",
        text: "A driver's license is a ____, not a right.",
        options: ["Certification", "Privilege", "Guarantee", "Contract"],
        correctAnswer: 1,
        scenario: "A driver's license is legally a **privilege**, not a right. The state of Ohio grants this privilege on the condition that you demonstrate the necessary skills, follow all traffic laws, and maintain physical and mental fitness to drive.",
        explanation: ""
    },
    {
        id: "M1-012",
        moduleId: "module-1",
        category: "Strategy",
        text: "Mental, social, and physical skills are all required for safe driving.",
        options: ["True", "False"],
        correctAnswer: 0,
        scenario: "Safe driving requires a balanced blend of **Mental skills** (hazard scanning, risk decisions), **Social skills** (cooperation with other users), and **Physical skills** (hand-eye coordination, muscle memory inputs).",
        explanation: ""
    },
    {
        id: "M1-013",
        moduleId: "module-1",
        category: "HTS",
        text: "Which HTS component is the most difficult to control?",
        options: ["Vehicles", "Yourself (The Driver)", "Other road users", "The weather"],
        correctAnswer: 2,
        scenario: "While you can train yourself, **other road users** represent the most difficult element to control. You must always drive defensively, expecting others to make sudden mistakes, run red lights, or fail to yield.",
        explanation: ""
    },
    {
        id: "M1-014",
        moduleId: "module-1",
        category: "Strategy",
        text: "The most common cause of collisions is ____.",
        options: ["Engine failure", "Bad roads", "Driver error", "Weather"],
        correctAnswer: 2,
        scenario: "Over **94% of all collisions are caused by driver error** (human error), such as distraction, speeding, or poor hazard evaluation. Weather and vehicle failures account for only 6%, meaning your personal driving habits are the ultimate factor in your survival.",
        explanation: ""
    },
    {
        id: "M1-015",
        moduleId: "module-1",
        category: "HTS",
        text: "Standardization of signs and signals is handled at the ____ level.",
        options: ["Local", "State", "Federal", "International"],
        correctAnswer: 2,
        scenario: "Standardization is established at the **Federal level** via the Manual on Uniform Traffic Control Devices (MUTCD). This ensures that a stop sign or red light has the exact same meaning in Ohio as it does in any other state.",
        explanation: ""
    },
    {
        id: "M1-016",
        moduleId: "module-1",
        category: "Laws",
        text: "Implied Consent means that by driving on Ohio roads, you agree to ____.",
        options: ["Pay all fines", "Blood alcohol testing if suspected of DUI", "Automatic insurance renewal", "Allow searches of your trunk"],
        correctAnswer: 1,
        scenario: "Under Ohio's **Implied Consent Law**, by operating a motor vehicle on public roads, you automatically agree to submit to **blood alcohol or chemical testing** if a law enforcement officer suspects you of operating a vehicle under the influence (OVI).",
        explanation: ""
    },
    {
        id: "M1-017",
        moduleId: "module-1",
        category: "HTS",
        text: "Traffic congestion is an example of an HTS ____.",
        options: ["Benefit", "Failure", "Requirement", "Efficiency"],
        correctAnswer: 1,
        scenario: "Traffic congestion and collisions are direct examples of an **HTS Failure**. They occur when one or more components of the system fail to operate in a safe, structured, and predictable manner.",
        explanation: ""
    },
    {
        id: "M1-018",
        moduleId: "module-1",
        category: "Security",
        text: "Locking your doors before driving improves ____.",
        options: ["Fuel economy", "Vehicle structural integrity in a crash", "Personal security", "Both B and C"],
        correctAnswer: 3,
        scenario: "Locking your doors improves both **personal security** (preventing carjacking or unwanted entry at stops) and **vehicle structural integrity** in a crash. In a rollover, locked latch mechanisms are far less likely to fail, preventing occupant ejection and maintaining the cabin's protective safety cage.",
        explanation: ""
    },
    {
        id: "M1-019",
        moduleId: "module-1",
        category: "Maintenance",
        text: "Where can you find the recommended tire pressure for your specific vehicle?",
        options: ["Side of the tire", "Owner's manual", "Driver's side door jamb sticker", "Both B and C"],
        correctAnswer: 3,
        scenario: "Never use the pressure listed on the tire's sidewall (that is the tire's absolute maximum pressure capacity, not the vehicle's safe running pressure). You can find the correct, recommended tire pressure in two locations: the **vehicle owner's manual** and the official **specification sticker inside the driver's side door jamb**.",
        explanation: ""
    },
    {
        id: "M1-020",
        moduleId: "module-1",
        category: "Strategy",
        text: "Successful HTS integration requires drivers to be ____ rather than competitive.",
        options: ["Aggressive", "Passage", "Cooperative", "Rapid"],
        correctAnswer: 2,
        scenario: "Drivers must be **cooperative** rather than competitive. Driving is a shared social endeavor; trying to 'beat' others or hog lanes disrupts traffic flow and increases crash risks.",
        explanation: ""
    },
    {
        id: "M1-021",
        moduleId: "module-1",
        category: "HTS",
        text: "What does the 'S' in HTS stand for, and what is its primary focus?",
        options: [
            "Speed - maximizing highway velocities",
            "System - connecting people, vehicles, and roadways safely",
            "Safety - auditing police traffic patrols",
            "Strategy - planning national transit routes"
        ],
        correctAnswer: 1,
        scenario: "**Correct Action**: **HTS stands for Highway Transportation System, focusing on connecting people, vehicles, and roadways safely.** Standardizing and managing these three parts reduces crashes and ensures efficient travel.",
        explanation: ""
    },
    {
        id: "M1-022",
        moduleId: "module-1",
        category: "Laws",
        text: "Under Ohio law, what is the legal definition of a 'motor vehicle'?",
        options: [
            "Any vehicle propelled by power other than muscular power, including passenger cars",
            "Only commercial transport semi-trucks",
            "Any device moved solely by human muscular force",
            "Electric bicycles exclusively"
        ],
        correctAnswer: 0,
        scenario: "**Correct Action**: **Ohio Revised Code defines a motor vehicle as any vehicle propelled by power other than muscular power, including passenger cars.** This legally distinguishes motor vehicles from muscular-propelled devices like standard bicycles.",
        explanation: ""
    },
    {
        id: "M1-023",
        moduleId: "module-1",
        category: "Strategy",
        text: "In driving, what is the definition of 'Risk'?",
        options: [
            "The certainty of a high-speed collision",
            "The chance of injury, damage, or loss inherent in any driving situation",
            "The cost of monthly auto insurance",
            "The legal speed limit on federal highways"
        ],
        correctAnswer: 1,
        scenario: "**Correct Action**: **Risk is defined as the chance of injury, damage, or loss inherent in any driving situation.** Defensive driving aims to identify and minimize this constant risk through active awareness.",
        explanation: ""
    },
    {
        id: "M1-024",
        moduleId: "module-1",
        category: "HTS",
        text: "Which of the following is a private cost of HTS failures?",
        options: [
            "Increased highway construction tax",
            "Destruction of public guardrails",
            "Elevated vehicle repair bills and medical expenses for individuals",
            "Federal transport safety audits"
        ],
        correctAnswer: 2,
        scenario: "**Correct Action**: **Elevated vehicle repair bills and medical expenses for individuals are private costs of HTS failures.** Public costs include highway taxes and damaged road infrastructure, while individuals bear the direct private financial strain.",
        explanation: ""
    },
    {
        id: "M1-025",
        moduleId: "module-1",
        category: "Safety",
        text: "Which level of driving task requires the driver to make real-time, micro-adjustments like steering and speed control?",
        options: ["Strategic level", "Tactical level", "Operational level", "Administrative level"],
        correctAnswer: 2,
        scenario: "**Correct Action**: **The Operational level of driving tasks involves real-time physical control (steering, braking, accelerator micro-adjustments).** Strategic tasks involve trip planning, and Tactical tasks cover passing and lane choices.",
        explanation: ""
    }
];
